<template>
  <div class="main-wrapper">
    <div>
      <layout-header></layout-header>
      <breadcrumb55></breadcrumb55>
      <!-- Page Content -->
      <div class="content">
        <div class="container">
          <div class="row">
            <div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
              <sidebar2></sidebar2>
            </div>
            <div class="col-md-7 col-lg-8 col-xl-9" v-if="showspinner">
              <loader></loader>
            </div>
            <div class="col-md-7 col-lg-8 col-xl-9" v-else>
              <div class="row ml-md-3">
                <div class="col-12">
                  <button class="new_btn btn btn-primary btn-sm" data-toggle="modal" @click="
                    $bvModal.show('add_new_patient');
                  " href="">Add New Patient</button>
                </div>
              </div>
              <div class="row row-grid ml-md-3 mt-2">
                <div class="col-md-6 col-lg-4 col-xl-3">
                  <input type="text" v-model="update_patient.patient" class="form-control mt-1" placeholder="Patient Name"
                    oninput="this.value = this.value.replace(/[^a-zA-Z]/g, '');" @input="filterPatients" />
                </div>
                <div class="col-md-6 col-lg-4 col-xl-3">
                  <input type="text" class="form-control mt-1" v-model="update_patient.mobile_no" placeholder="Mobile"
                    oninput="this.value = this.value.replace(/[^0-9]/g, '');" @input="filterPatients" />
                </div>
                <div class="col-md-6 col-lg-4 col-xl-3">
                  <input type="text" class="form-control mt-1" v-model="update_patient.city" placeholder="City"
                    oninput="this.value = this.value.replace(/[^a-zA-Z]/g, '');" @input="filterPatients" />
                </div>
              </div>
              <div class="row row-grid ml-md-3 mt-4" id="patient_container">
                <div class="col-md-6 col-lg-4 col-xl-4" v-for="(item, index) in patient" v-bind:key="index" :key="index"
                  v-show="setPaginate(index)">
                  <div class="profile-widget text-center">
                    <div class="profile-info-widget">
                      <a href="javascript:void(0);" class="booking-doc-img">
                        <img v-bind:src="item.image
                          ? config.base_url_for_Image + item.image
                          : loadImg('Patient Profile.svg')
                          " alt="User Image" style="border-radius: 50%; width: 80px; height:80px;" />
                      </a>
                      <div class="profile-det-info">
                        <h3>
                          <a href="javascript:void(0);">
                            {{ item.patient_name }}
                          </a>
                        </h3>

                        <div class="patient-details">
                          <h5 class="mb-0 mt-3">
                            <i class="fas fa-map-marker-alt"></i>
                            {{ item.city }},
                            {{ item.state }}
                          </h5>
                        </div>
                        <div class="patient-details mt-3">
                          <h5 class="mb-0">
                            <i class="fas fa-phone"></i>
                            {{ item.mobile }}
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <h5 v-if="patient.length === 0 && !showspinner" style="margin-left: -8%" class="No_data">
                No Patient Found
              </h5>

              <div class="row justify-content-center" v-if="patient.length > 12">
                <div>
                <h5 class="" style="color: #8d8c8c;">Total Patient : {{ total_patient }}</h5>
              </div>
              </div>
              <!-- pagination start -->
              <div id="pagination" class="ml-3" v-if="patient.length > 10">
                <ul class="pagination justify-content-center">

                  <!-- "Previous" Button -->
                  <li class="page-item" :class="current === 1 ? 'disabled' : ''">
                    <a href="#" class="page-link" aria-label="Previous"
                      @click.prevent="updateInvestigationCount(current - 1)">
                      Previous
                    </a>
                  </li>

                  <!-- Pagination Links (Display 5 at a time) -->
                  <li v-for="page_index in paginate_total" :key="page_index.id" :class="[
                    'page-item',
                    current === page_index ? 'active' : ''
                  ]" v-if="page_index >= current - 2 && page_index <= current + 2">
                    <a href="#" class="page-link" @click.prevent="updateInvestigationCount(page_index)">
                      {{ page_index }}
                    </a>
                  </li>

                  <!-- "Next" Button -->
                  <li class="page-item" :class="current === paginate_total ? 'disabled' : ''
                    ">
                    <a href="#" class="page-link" aria-label="Next"
                      @click.prevent="updateInvestigationCount(current + 1)">
                      Next
                    </a>
                  </li>
                </ul>
              </div>
              <!-- pagination end -->
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->
      <layout-footer></layout-footer>
    </div>
    <!-- new patient add modal -->
    <div>
      <b-modal id="add_new_patient" hide-footer>
        <!-- <template #modal-title> -->
        <template #modal-title>
          <h3 class="modal-title">Add New Patient</h3>
        </template>
        <div class="d-block text-center">
          <div class="card">
            <div class="card-body">
              <div class="modal-body">
                <div class="row form-row" v-if="!showOtpInput">
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <input type="text" name="first_name" required class="form-control floating"
                        v-model="register_patient.first_name" placeholder="First Name"
                        oninput="this.value = this.value.replace(/[^a-z A-Z]/g, '');" />
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <input type="text" name="last_name" required class="form-control floating"
                        v-model="register_patient.last_name" placeholder="Last Name"
                        oninput="this.value = this.value.replace(/[^a-zA-Z]/g, '');" />
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group" style="position: relative;">
                      <button class="btn btn-default" type="button"
                        style="position: absolute; left: 0; top: 0; border: 1px solid #ccc; border-right: none; background-color: lightgrey; height: 40px; border-radius: 4px 0 0 4px; z-index: 2;">91</button>
                      <input type="text" required maxlength="10" minlength="10" @keypress="onlyNumber"
                        v-model="register_patient.patient_mobile_no" class="form-control floating"
                        placeholder="Mobile Number" @keydown.enter.prevent="$refs.sendOtpButton.click()"
                        oninput="this.value = this.value.replace(/[^0-9]/g, '');"
                        style="padding-left: 60px; padding-top: 10px; padding-bottom: 10px; border-radius: 4px; letter-spacing: 2px;" />
                    </div>
                  </div>
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <v-select placeholder="Select City" v-model="register_patient.city" label="city"
                        :reduce="(option) => option.city" :options="cities" required>
                      </v-select>
                    </div>
                  </div>
                  <div class="col-12 col-md-12">
                    <div class="text-center mt-2">
                      <div class="submit-section text-left">
                        <button type="submit" id="medical_btn" class="btn btn-primary submit-btn" data-dismiss="modal"
                          aria-label="Close" @click="New_Patient_add()">
                          Send OTP
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div v-else class="col-md-12 col-lg-12">
                  <div class="login-header">
                    <h3 class="text-center">Enter OTP</h3>
                    <!-- <p class="small text-muted">Enter your OTP No</p> -->
                  </div>

                  <!-- Forgot Password Form -->
                  <div id="app">
                    <div class="otp-container">
                      <input v-for="(value, index) in otpValues" :key="index" type="text" maxlength="1" class="otp-input"
                        :value="value" @input="handleInput(index, $event.target.value)"
                        @keydown.backspace="handleBackspace(index)" ref="otpFields" @keypress="onlyNumber"
                        @keydown.enter.prevent="verify_OTP()" pattern="[0-9]*" autofocus />
                    </div>
                  </div>
                  <div class="mt-5">
                    <button ref="verifyOtpButton" class="btn btn-primary login-btn" type="submit" @click="verify_OTP()">
                      Verify OTP
                    </button>
                  </div>
                  <!-- /Forgot Password Form -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-modal>
    </div>
    <!-- new patient add modal end -->
  </div>
</template>

<script>
import { mapState } from "vuex";
import CommonApi from "../../../services/CommonApi";
import config from "../../../services/CommonApi";
const images = require.context("@/assets/img/patients");
import { VueDatePicker } from "@mathieustan/vue-datepicker";
import "@mathieustan/vue-datepicker/dist/vue-datepicker.min.css";
import axios from "axios";
export default {
  data() {
    return {
      otpValues: ["", "", "", "", "", ""],
      patient: [],
      total_patient: 0,
      cities: [],
      last_encounter: [],
      showspinner: true,
      config: config,
      format: "dd-MM-yyyy",
      appointment_type: "",
      selected_object: undefined,
      current: 1,
      paginate: 12,
      paginate_total: 0,
      showOtpInput: false,


      register_patient: {
        first_name: "",
        last_name: "",
        patient_mobile_no: "",
        city: "",
      },

      update_patient: {
        patient: "",
        city: "",
        mobile_no: ""
      }
    };
  },
  computed: {
    isOtpValid() {
      return this.otp.every((digit) => /\d/.test(digit)); // Check if all digits are numbers
    },
    ...mapState({
      user_id: (state) => state.user.user_id,
    }),

  },

  mounted() {
    let user = localStorage.getItem("userInfo");
    if (!user) {
      this.$router.push({ name: 'login' })
    }
    this.get_cities();
    this.my_patients();
  },

  components: { VueDatePicker },

  methods: {

    onCitySelect(selectedCity) {
      this.register_patient.city = selectedCity;
    },

    async get_cities() {
      this.selected_city = "";
      await CommonApi.get_data("sahaj.finalapi.get_city").then((res) => {
        this.cities = res.message;
      });
    },

    handleInput(index, value) {
      if (value.length > 1) {
        return;
      }
      this.otpValues[index] = value;
      if (value.length === 1 && index < this.otpValues.length - 1) {
        this.$refs.otpFields[index + 1].focus();
      }
    },
    handleBackspace(index) {
      if (this.otpValues[index] !== "") {
        this.otpValues[index] = "";
      } else if (index > 0) {
        this.$refs.otpFields[index - 1].focus();
      }
    },

    verify_OTP() {
      const fullOtp = this.otpValues.join("");
      if (this.register_patient.patient_mobile_no && fullOtp) {
        this.$swal({
          text: "Verifying OTP...",
          showConfirmButton: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });
        var bodyFormData = new FormData();
        bodyFormData.append("phone", this.register_patient.patient_mobile_no);
        bodyFormData.append("otp", fullOtp);

        CommonApi.post_data("sahaj.api.verify_otp_code", bodyFormData, true).then((res) => {
          if (res.status_code === 200) {
            this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
            });
            this.registerPatient();
          } else {
            // OTP verification failed
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: res.message,
              showConfirmButton: true,
            });
          }
        });
      }
    },

    registerPatient() {
      this.$swal({
        text: "Creating your account",
        showConfirmButton: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      let data = {
        first_name: this.register_patient.first_name,
        last_name: this.register_patient.last_name,
        mobile_no: this.register_patient.patient_mobile_no,
        city: this.register_patient.city,
      };

      CommonApi.post_data("sahaj.login.register_patient", data, true).then((res) => {
        if (res.status_code === 200) {
          this.$swal.fire({
              icon: "success",
              title: "Success",
              text: res.message,
              showConfirmButton: true,
            }).then(() => {
              window.location.reload();
            });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Error",
            text: res.message,
            showConfirmButton: true,
          });
        }
      });
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        // 46 is dot
        $event.preventDefault();
      }
    },

    filterPatients() {
      if (
        this.update_patient.patient === '' &&
        this.update_patient.mobile_no === '' &&
        this.update_patient.city === ''
      ) {
        this.my_patients();
      } else {
        const filteredPatients = this.patient.filter((item) => {
          const patientNameMatch = item.patient_name.toLowerCase().includes(this.update_patient.patient.toLowerCase());
          const mobileMatch = item.mobile.includes(this.update_patient.mobile_no);
          const cityMatch = item.city.toLowerCase().includes(this.update_patient.city.toLowerCase());

          return patientNameMatch && mobileMatch && cityMatch;
        });

        this.patient = filteredPatients;
        this.paginate_total = Math.ceil(this.patient.length / this.paginate);
      }
    },


    async New_Patient_add() {
      if (this.register_patient) {
        var bodyFormData = new FormData();
        bodyFormData.append("phone", this.register_patient.patient_mobile_no);
        CommonApi.post_data("sahaj.api.send_otp", bodyFormData, true).then(
          (res) => {
            if (res.status_code == 200) {
              this.showOtpInput = true;
              this.$swal.fire({
                icon: "success",
                title: "Success",
                text: res.message,
              });
              setTimeout(() => {
                this.$swal.close();
              }, 1000);
            } else {
              this.$swal.fire({
                icon: "error",
                title: "Error",
                text: res.message,
                showConfirmButton: true,
              });
            }
          }
        );
      }
    },

    //pagination start
    updateInvestigationCount(i) {
      this.current = i;
      document.getElementById("patient_container").scrollIntoView();
    },


    setPaginate(i) {
      if (this.current == 1) {
        return i < this.paginate;
      } else {
        return (
          i >= this.paginate * (this.current - 1) &&
          i < this.current * this.paginate
        );
      }
    },
    //pagination end


    get_moment(obj) {
      return moment(obj);
    },

    loadImg(imgPath) {
      return images("./" + imgPath);
    },


    /* Get Patient  */
    async my_patients() {
      const params = new URLSearchParams();
      const hospitalInfo = localStorage.getItem('hospitalID');
      if (hospitalInfo) {
        const hospitalName = JSON.parse(hospitalInfo).hospital;
        params.append("hospital", hospitalName);
      } else {
        console.error("Hospital information not found in local storage");
        return;
      }
      await CommonApi.get_data("sahaj.hospital.get_hospital_patients", params).then((res) => {
        this.showspinner = false;
        if (res && res.data) {
          this.total_patient = res.data.patient_list.length;
          this.patient = res.data.patient_list;
          this.paginate_total = Math.ceil(this.patient.length / this.paginate);
        }
      });
    },

  },
};
</script>

<style scoped>
.appointment-modal {
  display: block;
  text-align: center;
}

.appointment-modal-no-border {
  border: none !important;
}

.timing {
  cursor: pointer;
}

.active {
  background-color: #66CDAA !important;
  color: #fff !important;
}

.slot_number {
  background-color: #4682B4;
  color: #fff;
  padding-left: 6px;
  padding-right: 6px;
  padding-top: 2px;
  padding-bottom: 2px;
  border-radius: 100%;
}

.rounded-brackets {
  font-size: 14px;
  display: inline-flex;
  align-items: center;
  border: 1px solid #F8F8F8;
  border-radius: 50%;
  padding: 5px 10px;
  margin: 0 5px;
}

.active-item {
  color: #66CDAA;
}

.submit-btn:hover {
  background-color: #008080;
}

.submit-btn:active {
  background-color: #008080;
}


body {
  height: 100%;
  width: 100%;
  background-color: #333;
}

.opt {
  text-align: center;
  letter-spacing: 15px;
}

#countdown {
  position: relative;
  margin: auto;
  margin-top: 8px;
  height: 40px;
  width: 40px;
  text-align: center;
}

#countdown-number {
  color: black;
  display: inline-block;
  line-height: 40px;
}

svg {
  position: absolute;
  top: 0;
  right: 0;
  width: 40px;
  height: 40px;
  transform: rotateY(-180deg) rotateZ(-90deg);
}

svg circle {
  stroke-dasharray: 113px;
  stroke-dashoffset: 0px;
  stroke-linecap: round;
  stroke-width: 2px;
  stroke: red;
  fill: none;
  animation: countdown 60s linear forwards;
}

.otp-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.otp-input {
  width: 40px;
  height: 40px;
  text-align: center;
  font-size: 24px;
  margin: 0 10px;
  border: none;
  border-bottom: 2px solid #403636;
  box-shadow: none;
  background-color: transparent;
  color: #140b0b;
  transition: all 0.3s ease-in-out;
  font-family: Arial, Helvetica, sans-serif;
}

.otp-input:focus {
  outline: none;
  border-bottom: 2px solid #09e5ab;
}
.new_btn:hover{
background-color: #008080;
}

@keyframes countdown {
  from {
    stroke-dashoffset: 0px;
  }

  to {
    stroke-dashoffset: 113px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/kneexpert/hospital/Patients.vue